// extracted by mini-css-extract-plugin
export default {"data-display":"DisplaySection_data-display__zGlSh","fields":"DisplaySection_fields__qqJmw","wrapper":"DisplaySection_wrapper__vAc0b","preview":"DisplaySection_preview__lF6+E"};